import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue')
  },
  {
    path: '/projects',
    name: 'Projects',
    component: () => import('@/views/Projects.vue')
  },
  {
    path: '/resources',
    name: 'Resources',
    component: () => import('@/views/Resources.vue')
  },
  {
    path: '/user',
    name: 'User',
    component: () => import('@/views/User.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue')
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/ForgotPassword.vue')
  },
  {
    path: '/books',
    name: 'Books',
    component: () => import('@/views/Books.vue')
  },
  {
    path: '/music',
    name: 'MusicList',
    component: () => import('@/views/MusicList.vue')
  },
  {
    path: '/file-share',
    name: 'FileShare',
    component: () => import('@/views/FileShare.vue'),
    meta: { requiredModule: 'file_share' }
  },
  {
    path: '/imusic',
    name: 'IMusicList',
    component: () => import('@/music/pages/music-list.vue'),
    meta: { requiredModule: 'imusic' }
  },
    {
      path: '/imusic/share/music/:shareId',
      name: 'MusicShare',
      component: () => import('@/components/music/DXHmusicSharePage.vue'),
      props: true
    },
    {
      path: '/imusic/share/batch/:shareId',
      name: 'MusicBatchShare',
      component: () => import('@/components/music/DXHmusicSharePage.vue'),
      props: (route) => ({
        shareId: route.params.shareId,
        isBatch: true
      })
    },
    {
      path: '/s/:shortCode',
      name: 'ShortLinkRedirect',
      component: () => import('@/components/ShortLinkRedirect.vue'),
      props: true,
      meta: {
        hideHeader: true // 标记隐藏导航栏
      }
    },
  {
    path: '/music/player',
    name: 'Music',
    component: () => import('@/views/Music.vue')
  },
  {
    path: '/wallpapers',
    name: 'Wallpapers',
    component: () => import('@/views/Wallpapers.vue')
  },
  {
    path: '/blog',
    name: 'Blog',
    component: () => import('@/views/Blog.vue')
  },
  {
    path: '/blog/:id',
    name: 'BlogPost',
    component: () => import('@/views/BlogPost.vue')
  },
  {
    path: '/projects/tangtanglove',
    name: 'TangTangLove',
    component: () => import('@/components/projects/TangTangLove.vue'),
    meta: {
      hideHeader: true,
      requiredModule: 'tangtang_love'
    }
  },
  {
    path: '/projects/resume-generator',
    name: 'ResumeGenerator',
    component: () => import('@/views/resume-generator/ResumeGenerator.vue'),
    meta: {
      hideHeader: true,
      requiredModule: 'resume_generator',
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: '/projects/bead-pattern-generator',
    name: 'BeadPatternGenerator',
    component: () => import('@/components/PinDou/PinDou.vue')
  },
  {
    path: '/test-draggable',
    name: 'TestDraggable',
    component: () => import('@/testSomething/TestDraggable.vue')
  },
  {
    path: '/dev/particle-text-effect',
    name: 'ParticleTextEffectTest',
    component: () => import('@/testSomething/ParticleTextEffectTest.vue'),
    meta: {
      hideHeader: true,
      allowTextSelection: true
    }
  },
  {
    path: '/dev/lattice-playback',
    name: 'LatticePlaybackTest',
    component: () => import('@/testSomething/LatticePlaybackTest.vue'),
    meta: {
      hideHeader: true
    }
  },
  {
    path: '/dev/word-lyrics',
    name: 'WordLyricsTest',
    component: () => import('@/testSomething/WordLyricsTest.vue'),
    meta: {
      hideHeader: true,
      allowTextSelection: true
    }
  },
  {
    path: '/dev/music-account',
    name: 'MusicAccountTest',
    component: () => import('@/testSomething/MusicAccountTest.vue'),
    meta: {
      hideHeader: true,
      allowTextSelection: true
    }
  },
  {
    path: '/dev/image-particle-3d',
    name: 'ImageParticle3DTest',
    component: () => import('@/testSomething/ImageParticle3DTest.vue'),
    meta: {
      hideHeader: true,
      allowTextSelection: true
    }
  },
  {
    path: '/admin-test',
    name: 'AdminTest',
    component: () => import('@/testSomething/testAdmin/AdminTest.vue'),
    meta: {
      allowTextSelection: true
    }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('@/views/admin/index.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      allowTextSelection: true
    }
  },
  {
    path: '/test-button',
    name: 'TestButton',
    component: () => import('@/views/TestButton.vue')
  },
  {
    path: '/upload-test',
    name: 'UploadTest',
    component: () => import('@/views/testSomething/UploadTest.vue')
  },
  {
    path: '/icity-music-test',
    name: 'IcityMusicTest',
    component: () => import('@/testSomething/IcityStyleMusicTest.vue')
  },
  {
    path: '/test-music-list',
    name: 'TestMusicList',
    component: () => import('@music-pages/music-list.vue')
  },
  {
    path: '/permission-test',
    name: 'PermissionTest',
    component: () => import('@/views/PermissionTest.vue')
  },
  {
    path: '/music-auth-demo',
    name: 'MusicAuthDemo',
    component: () => import('@/views/MusicAuthDemo.vue')
  },
  {
    path: '/music-auth',
    name: 'MusicAuthFullscreen',
    component: () => import('@/views/MusicAuthFullscreen.vue')
  },
  {
    path: '/douyin-bgm-test',
    name: 'DouyinBgmTest',
    component: () => import('@/pages/douyin-bgm-test.vue')
  },
  {
    path: '/kukutool-parse-test',
    name: 'KukuToolParseTest',
    component: () => import('@/pages/kukutool-parse-test.vue')
  },
  {
    path: '/ai-image-pixel-test',
    name: 'AiImagePixelTest',
    component: () => import('@/pages/ai-image-pixel-test.vue')
  },
  {
    path: '/todo',
    name: 'Todo',
    component: () => import('@/views/Todo.vue'),
    meta: {
      requiresAuth: true,
      hideHeader: true,
      requiredModule: 'todo'
    }
  },
  {
    path: '/storage-test',
    name: 'StorageTest',
    component: () => import('@/views/StorageTest.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/aliyun-direct-test',
    name: 'AliyunDirectTest',
    component: () => import('@/views/testSomething/AliyunDirectTest.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/demo/copied-modal',
    name: 'CopiedModalPreview',
    component: () => import('@/views/demo/CopiedModalPreview.vue'),
    meta: {
      hideHeader: true
    }
  },
  {
    path: '/demo/animations-dev',
    name: 'AnimationsDevReplica',
    component: () => import('@/views/demo/animations-dev/AnimationsDevReplica.vue'),
    meta: {
      hideHeader: true
    }
  }
]

const router = createRouter({
  history: createWebHistory('/'),
  routes
})

// 导入tokenService
import tokenService from '@/utils/tokenService';
import { useAuthModalStore } from '@/store/authModal';
import { useModuleStore } from '@/store/module';
import {
  applyAdminMobileViewport,
  isAdminRoutePath,
  restoreDefaultViewport
} from '@/utils/adminMobileViewport';
import { showGlobalToast } from '@/utils/globalToast';

async function ensureModuleAccess(to, next) {
  const requiredModule = to.matched.find(record => record.meta.requiredModule)?.meta.requiredModule;
  if (!requiredModule) {
    return true;
  }
  const userRole = tokenService.getUserRoleFromToken(tokenService.getAccessToken());
  if (userRole === 1) {
    return true;
  }
  const moduleStore = useModuleStore();
  await moduleStore.fetchModules();
  if (!moduleStore.hasModule(requiredModule)) {
    moduleStore.openActivationModal({
      title: String(to.name || ''),
      link: to.fullPath,
      moduleCode: requiredModule
    });
    next({ path: '/' });
    return false;
  }
  return true;
}

// 导航守卫
router.beforeEach(async (to, from, next) => {
  // 检查是否有有效的JWT Token
  const hasValidToken = tokenService.hasAccessToken();

  console.log('路由守卫检查权限:', {
    hasValidToken,
    path: to.path,
    fromPath: from.path,
    tokenInfo: {
      hasAccessToken: tokenService.hasAccessToken(),
      hasRefreshToken: tokenService.hasRefreshToken()
    }
  });

  // 检查路由是否需要身份验证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 用户未登录，打开登录弹窗并停留在当前页面
    if (!hasValidToken) {
      console.log('用户未登录，打开登录弹窗');
      // 保存重定向目标
      sessionStorage.setItem('redirectAfterLogin', to.fullPath);
      // 如果不在首页，先跳转到首页
      if (to.path !== '/') {
        next({ path: '/', query: { auth: 'login' } });
      } else {
        // 已经在首页，直接打开弹窗
        const authModal = useAuthModalStore();
        authModal.open('login');
        next(false); // 取消导航
      }
      return;
    }

    // 检查是否需要管理员权限
    if (to.matched.some(record => record.meta.requiresAdmin)) {
      // 使用tokenService的方法获取用户角色
      const accessToken = tokenService.getAccessToken();
      if (accessToken) {
        const userRole = tokenService.getUserRoleFromToken(accessToken);
        console.log('路由守卫检查管理员权限, 当前角色:', userRole);

        if (userRole !== 1) {
          console.log('需要管理员权限但用户不是管理员, 当前角色:', userRole);
          // 用户不是管理员，重定向到首页
          next({ path: '/' });
          return;
        }
      } else {
        console.log('无法获取用户角色信息，打开登录弹窗');
        // 保存重定向目标
        sessionStorage.setItem('redirectAfterLogin', to.fullPath);
        // 如果不在首页，先跳转到首页
        if (to.path !== '/') {
          next({ path: '/', query: { auth: 'login' } });
        } else {
          // 已经在首页，直接打开弹窗
          const authModal = useAuthModalStore();
          authModal.open('login');
          next(false); // 取消导航
        }
        return;
      }
    }

    // 用户已登录且有权限，检查功能模块
    const moduleAllowed = await ensureModuleAccess(to, next);
    if (!moduleAllowed) {
      return;
    }
    console.log('用户有权限访问此页面');
    next();
  }
  // 功能模块权限校验（需登录）
  else if (to.matched.some(record => record.meta.requiredModule)) {
    const requiredModule = to.matched.find(record => record.meta.requiredModule)?.meta.requiredModule;
    if (!hasValidToken) {
      sessionStorage.setItem('redirectAfterLogin', to.fullPath);
      if (to.path === '/imusic') {
        next({ path: '/music-auth' });
      } else if (to.path !== '/') {
        next({ path: '/', query: { auth: 'login' } });
      } else {
        const authModal = useAuthModalStore();
        authModal.open('login');
        next(false);
      }
      return;
    }

    const moduleAllowed = await ensureModuleAccess(to, next);
    if (!moduleAllowed) {
      return;
    }
    next();
  }
  // 如果是登录页面且用户已登录，重定向到首页
  else if (to.path === '/login' && hasValidToken) {
    console.log('用户已登录，尝试访问登录页，重定向到首页');
    next({ path: '/' });
  }
  // 🔥 特殊处理：/imusic 路由需要登录，如果未登录直接跳转到音乐认证页面
  else if (to.path === '/imusic' && !hasValidToken) {
    console.log('用户未登录，访问 /imusic 路由，重定向到音乐认证页面');
    next({ path: '/music-auth' });
    return;
  }
  // 路由不需要身份验证，直接访问
  else {
    next();
  }
});

// 懒加载 chunk 失败（部署更新、开发期 HMR 模块图损坏、网络中断）时，
// Vue Router 只会抛错并中止导航，用户看到的是「点了没反应」。
// 这里兜底提示，至少让用户知道需要刷新，而不是页面毫无反馈。
router.onError((error) => {
  const msg = String(error?.message || error || '');
  const isChunkLoadFailure =
    /dynamically imported module|module script failed|Importing a module script|Loading chunk/i.test(msg);
  if (!isChunkLoadFailure) return;
  showGlobalToast('页面资源加载失败，请刷新页面后重试');
});

const ADMIN_SELECTABLE_CLASS = 'admin-selectable';

function syncAdminTextSelection(route) {
  const allowSelection = route.matched.some((record) => record.meta.allowTextSelection);
  document.documentElement.classList.toggle(ADMIN_SELECTABLE_CLASS, allowSelection);
}

function syncAdminMobileViewport(route) {
  if (isAdminRoutePath(route.path)) {
    applyAdminMobileViewport()
  } else {
    restoreDefaultViewport()
  }
}

router.afterEach((to) => {
  syncAdminTextSelection(to);
  syncAdminMobileViewport(to);
});

router.isReady().then(() => {
  syncAdminTextSelection(router.currentRoute.value);
  syncAdminMobileViewport(router.currentRoute.value);
});

export default router